export default "__VITE_ASSET__DXS01RXS__"